module.exports = __webpack_public_path__ + "img/Argentina.9dc517ac.png";